import service from '@/utils/request'; // CreateBairunStationDiscountPrice 添加油站优惠
// @Tags Price
// @Summary 添加油站优惠价
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunRequest.BairunStationDiscountPriceRequest true "添加油站优惠价"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /priceManage/stationDiscountPrice/create [post]

export var createBairunStationDiscountPrice = function createBairunStationDiscountPrice(data) {
  return service({
    url: '/priceManage/stationDiscountPrice/create',
    method: 'post',
    data: data
  });
}; // DeleteBairunStationDiscountPrice 删除油站优惠
// @Tags Price
// @Summary 删除油站优惠
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunRequest.BairunStationDiscountPriceRequest true "删除油站优惠"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"删除成功"}"
// @Router /priceManage/stationDiscountPrice/delete [delete]

export var deleteBairunStationDiscountPrice = function deleteBairunStationDiscountPrice(data) {
  return service({
    url: '/priceManage/stationDiscountPrice/delete',
    method: 'post',
    data: data
  });
}; // DeleteBairunStationDiscountPriceByIds 批量删除油站优惠
// @Tags Price
// @Summary 批量删除油站优惠
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.IdsReq true "批量删除油站优惠"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"批量删除成功"}"
// @Router /priceManage/stationDiscountPrice/deleteByIds [delete]

export var deleteBairunStationDiscountPriceByIds = function deleteBairunStationDiscountPriceByIds(data) {
  return service({
    url: '/priceManage/stationDiscountPrice/deleteByIds',
    method: 'post',
    data: data
  });
}; // UpdateBairunStationDiscountPrice 更新油站优惠
// @Tags Price
// @Summary 更新油站优惠
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunRequest.BairunStationDiscountPriceRequest true "更新油站优惠"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"更新成功"}"
// @Router /priceManage/stationDiscountPrice/update [put]

export var updateBairunStationDiscountPrice = function updateBairunStationDiscountPrice(data) {
  return service({
    url: '/priceManage/stationDiscountPrice/update',
    method: 'put',
    data: data
  });
}; // FindBairunStationDiscountPrice 查找油站优惠
// @Tags Price
// @Summary 查找油站优惠
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunRequest.BairunStationDiscountPriceRequest true "查找油站优惠"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"查询成功"}"
// @Router /priceManage/stationDiscountPrice/find [get]

export var findBairunStationDiscountPrice = function findBairunStationDiscountPrice(params) {
  return service({
    url: '/priceManage/stationDiscountPrice/find',
    method: 'get',
    params: params
  });
}; // GetBairunStationDiscountPriceList 分页获取油站优惠
// @Tags Price
// @Summary 分页获取油站优惠
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunRequest.BairunStationDiscountPriceSearch true "分页获取油站优惠"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /priceManage/stationDiscountPrice/getList [get]

export var getBairunStationDiscountPriceList = function getBairunStationDiscountPriceList(params) {
  return service({
    url: '/priceManage/stationDiscountPrice/getList',
    method: 'get',
    params: params
  });
};